var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8A8 8 0 110 8a8 8 0 0116 0zM3.914 12.086a.75.75 0 010-1.06L6.94 8 3.914 4.975a.75.75 0 011.06-1.06L8 6.938l3.025-3.025a.75.75 0 011.06 1.06L9.062 8l3.025 3.025a.75.75 0 01-1.06 1.06L8 9.062l-3.025 3.025a.75.75 0 01-1.06 0z",
    fill: "currentColor"
  })));
}
export default SvgCancelRound;